"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PARTNER_AGENT_ROLES_NL = exports.PartnerAgentRole = void 0;
var PartnerAgentRole;
(function (PartnerAgentRole) {
    PartnerAgentRole["Admin"] = "Admin";
    PartnerAgentRole["CompanyManager"] = "CompanyManager";
    PartnerAgentRole["Employee"] = "Employee";
    PartnerAgentRole["MultiOfficeManager"] = "MultiOfficeManager";
    PartnerAgentRole["OfficeManager"] = "OfficeManager";
    PartnerAgentRole["OrganizationManager"] = "OrganizationManager";
})(PartnerAgentRole = exports.PartnerAgentRole || (exports.PartnerAgentRole = {}));
exports.PARTNER_AGENT_ROLES_NL = {
    [PartnerAgentRole.Admin]: 'Admin',
    [PartnerAgentRole.MultiOfficeManager]: 'Manager van meerdere kantoren',
    [PartnerAgentRole.OfficeManager]: 'Kantoormanager',
    [PartnerAgentRole.CompanyManager]: 'Bedrijfsmanager',
    [PartnerAgentRole.OrganizationManager]: 'Organisatiemanager',
    [PartnerAgentRole.Employee]: 'Medewerker',
};
